import type { ReactNode } from "react";
import styles from "./AppBanner.module.scss";

interface AppBannerProps {
  children: ReactNode;
}

// Multiple banners can be "stacked" as needed here, by placing them above the <div /> containing styles.wrapper.
export default function AppBanner({ children }: AppBannerProps) {
  return (
    <>
      <div className={styles.wrapper}>{children}</div>
    </>
  );
}
